module.exports = __webpack_public_path__ + "static/media/Step1.51dfd9f5.png";